import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDroper_open } from "../../redux/Close_droper";
import i18n from "../../i18n";

const LanguageDropdown = () => {

  const [open, setOpen] = useState(false);

  const Droper_open = useSelector((state) => state.droper_open.selected);
  const dispatch = useDispatch();

  useEffect(() => {
    if (Droper_open === false) {
      setOpen(false);
    }
  }, [Droper_open]);

  const languages = [
    {
      code: "en",
      label: "English",
      flag: "/Images/united-states-of-america.png"
    },
    {
      code: "tr",
      label: "Turkey",
      flag: "/Images/turkey.png"
    },
    {
      code: "de",
      label: "Germany",
      flag: "/Images/germany.png"
    }
  ];

  // detect current language
  const currentLang = i18n.language || "en";
  const defaultLang = languages.find(lang => lang.code === currentLang) || languages[0];

  const [selected, setSelected] = useState(defaultLang);

  const handleLanguageChange = (lang) => {
    setSelected(lang);
    i18n.changeLanguage(lang.code); // ✅ THIS CHANGES LANGUAGE
    localStorage.setItem("language", lang.code); // optional persist
    setOpen(false);
    dispatch(setDroper_open(false));
  };

  return (
    <div className="dropdown ml-3" onClick={(e) => e.stopPropagation()}>

      <button
        className="btn text-light d-flex align-items-center gap-2"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
          dispatch(setDroper_open(true));
        }}
      >
        <img src={selected.flag} alt="" width="30px" />
        <span>{selected.label}</span>
      </button>

      {
        open && (
          <ul className="dropdown-menu show mt-1 p-0" style={{ display: "block" }}>
            {languages.map((lang) => (
              <li
                key={lang.code}
                className="dropdown-item bg-light d-flex align-items-center gap-2 pe-2"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleLanguageChange(lang);
                }}
              >
                <img src={lang.flag} alt="" width="30px" />
                <span>{lang.label}</span>
              </li>
            ))}
          </ul>
        )
      }

    </div>
  );
};

export default LanguageDropdown;
